import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgMobile = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	"aria-hidden": "true",
	...props,
	children: /* @__PURE__ */ _jsx("g", {
		transform: "translate(4.9992 0.2496)",
		children: /* @__PURE__ */ _jsx("path", {
			id: "Icon",
			d: "M10.2041 3.76074C11.2128 3.863 12 4.71435 12 5.75V19.75C12 20.7857 11.2128 21.637 10.2041 21.7393L10 21.75H2C0.964349 21.75 0.113005 20.9628 0.0107422 19.9541L0 19.75V5.75C0 4.64543 0.895431 3.75 2 3.75H10L10.2041 3.76074ZM2 5.25C1.72386 5.25 1.5 5.47386 1.5 5.75V19.75C1.5 20.0261 1.72386 20.25 2 20.25H10C10.2761 20.25 10.5 20.0261 10.5 19.75V5.75C10.5 5.47386 10.2761 5.25 10 5.25H2ZM6 16.75C6.55228 16.75 7 17.1977 7 17.75C7 18.3023 6.55228 18.75 6 18.75C5.44772 18.75 5 18.3023 5 17.75C5 17.1977 5.44772 16.75 6 16.75ZM10 0C13.1756 0 15.75 2.57436 15.75 5.75V7.75H14.25V5.75C14.25 3.40279 12.3472 1.5 10 1.5H9V0H10Z",
			fill: "currentColor"
		})
	})
});
export default SvgMobile;
